import React, {useState, useMemo, useEffect, useContext} from "react";
import LikedItemsContext from "./LikedItemsContext";
import UserDataAPI from "../../api/firebase/UserDataAPI";
import UserProfileContext from "../userProfile/UserProfileContext";
const LikedItemsState = (props) => {
  const [state, setState] = useState([]);
  const [isFirstRender, setIsFirstRender] = useState(true);
  const userDataApi = new UserDataAPI();
  const userProfileContext = useContext(UserProfileContext);
  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state]
  );
  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("likedItems"));
    // console.log("UseEffect===========localstorage:", items);
    if (items) {
      setState([...items]);
    }
  }, []);
  useEffect(() => {
    // console.log("likedItems items state:", state);
    // console.log("userProfileContext.state:", userProfileContext.state);
    if (!isFirstRender) {
      localStorage.setItem("likedItems", JSON.stringify(state));
      if (userProfileContext.state !== null && state !== null) {
        const dataToSend = {
          payload: {
            likedItems: state,
          },
          id: userProfileContext.state.id,
        };
        //console.log("data to send:", dataToSend);
        userDataApi
          .addUserData(dataToSend)
          .then((res) => {
            //console.log("RES:", res);
            if (res.success) {
              userProfileContext.setState((prev) => ({
                ...prev,
                ...dataToSend.payload,
              }));
            }
          })
          .catch((err) => {
            console.log("ERR:", err);
          });
      }

      // console.log(
      //   "localstorage likedItems:",
      //   JSON.parse(localStorage.getItem("likedItems"))
      // );
    }
    return setIsFirstRender(false);
  }, [state]);
  return (
    <LikedItemsContext.Provider value={value}>
      {props.children}
    </LikedItemsContext.Provider>
  );
};

export default LikedItemsState;
